import { Link, useParams } from 'react-router-dom';

import { Card } from '../../components/ui';

export function Registered() {
  const { slug, eventId } = useParams<{ slug: string; eventId: string }>();
  return (
    <div className="min-h-screen bg-cream-100 px-6 py-10 flex items-center justify-center">
      <Card className="p-8 max-w-md text-center space-y-4">
        <h1 className="font-display text-3xl">You're in</h1>
        <p className="text-ink-muted">
          Confirmation sent to your email. Check your inbox for event details.
        </p>
        {/* TODO(section-7): Stripe checkout redirect if event.price &gt; 0 and payment not yet received */}
        <Link to={`/${slug}/events/${eventId}`} className="underline">
          ← Back to event
        </Link>
      </Card>
    </div>
  );
}
